import { IStorageForecastingAccessResponseDto } from '@/interfaces/auth/IStorageForecastingAccess.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('storageForecasting');

async function getUserAccess (): Promise<IStorageForecastingAccessResponseDto> {
    return (await apiCall.get<IStorageForecastingAccessResponseDto>({ endpoint: '/api/GetUserAccess' })).data;
}

export const longTermForecastingAccessApi = {
    getUserAccess,
};
